(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4505],{

/***/ 85641:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airdrops",
      function () {
        return __webpack_require__(27733);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ airdrops; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/airdrop/hooks/useQuery.tsx
var useQuery = __webpack_require__(70611);
// EXTERNAL MODULE: ./src/airdrop/components/AllAirdropsGrid.js + 8 modules
var AllAirdropsGrid = __webpack_require__(73925);
// EXTERNAL MODULE: ./src/components/common/PageHead.tsx
var PageHead = __webpack_require__(47270);
// EXTERNAL MODULE: ./src/airdrop/components/Container.tsx
var Container = __webpack_require__(54167);
// EXTERNAL MODULE: ./src/config/config.js
var config = __webpack_require__(35055);
// EXTERNAL MODULE: ./node_modules/antd/es/result/index.js + 5 modules
var result = __webpack_require__(33859);
;// CONCATENATED MODULE: ./src/components/common/Maintenance.tsx


var Maintenance = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(result/* default */.ZP, {
        status: "warning",
        title: "Server is under maintenance, please wait a moment"
    });
};
/* harmony default export */ var common_Maintenance = (Maintenance);

;// CONCATENATED MODULE: ./src/pages/airdrops/index.tsx







var Campaigns = function() {
    var page = (0,useQuery/* useQuery */.a)();
    var type = page.get("type") ? page.get("type") : "ALL";
    var pageNumber = page.get("page") ? page.get("page") : 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-trendingBg bg-contain bg-no-repeat",
                style: {
                    backgroundPosition: "left -90px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-28 w-full max-w-5xl px-6 mx-auto pt-[100px]",
                    children: config/* isMaintenance */.b6 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Maintenance, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AllAirdropsGrid/* default */.Z, {
                        pageNum: pageNumber,
                        type: type
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var airdrops = (Campaigns);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3454,2280,6034,7258,4304,6518,7065,3363,3859,7172,2256,7356,8517,1032,8478,9774,2888,179], function() { return __webpack_exec__(85641); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);